// extracted by mini-css-extract-plugin
export default {"mailingFormContainer":"AdminMailingForm_mailingFormContainer__C7xXe"};